export const BASE_URL = 'https://stock.kntgroup.eu';
// export const BASE_URL = 'http://localhost:8001';